<template lang="pug">
  .asp-home(:style="`background-image: url(${ backgroundImage })`")

</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { mapGetters } from 'vuex'

@Component({
  computed: mapGetters([
    'userTenantId'
  ])
})
export default class Home extends Vue {
  get backgroundImage () {
    if (this.userTenantId === 'VKB') {
      return require('@/assets/images/vkb-rms-home-keyvisual.jpg')
    }

    if (this.userTenantId === 'FSOEL') {
      return require('@/assets/images/fsoel-rms-home-keyvisual.jpg')
    }

    if (this.userTenantId === 'SAV') {
      return require('@/assets/images/sav-rms-home-keyvisual.jpg')
    }

    return ''
  }
}
</script>

<style lang="sass">
.asp-home
  position: absolute
  top: 0
  left: 0
  bottom: 0
  right: 0
  background-position: center
  background-repeat: no-repeat
  background-size: cover
</style>
